// extracted by mini-css-extract-plugin
module.exports = {"columnHeader":"ColumnHeader_columnHeader__8_Gga","columnHeaderText":"ColumnHeader_columnHeaderText__0pFBW"};